import { MARCA } from '../core/componentes.js';
import { db } from '../data/db.js';

/* =====================================================================
   LOGIN
   ===================================================================== */
export function vistaLogin(){
  return `<div class="login-wrap">
    <div class="login-art">${MARCA(true,false)}
      <div><div class="login-claim">Cada euro,<br>en su <em>kilómetro</em>.</div>
        <p class="login-sub">Contratos, pedidos, partes de trabajo y certificaciones en un solo sitio. Se acabó la hoja de cálculo compartida a medias.</p></div>
      <div class="kpi-strip">
        <div><span class="n">${db.contratos.filter(c=>c.estado==='activo').length}</span><span class="l">Contratos vivos</span></div>
        <div><span class="n">${db.pedidos.filter(p=>!['servido','anulado'].includes(p.estado)).length}</span><span class="l">Pedidos abiertos</span></div>
      </div></div>
    <div class="login-form">${MARCA(false,true)}
      <h2 style="margin-top:34px">Entrar</h2><p class="hint">Accede con tus credenciales del servicio.</p>
      <div class="campo"><label for="em">Correo</label><input id="em" type="email" placeholder="nombre@carreteras.es"></div>
      <div class="campo"><label for="pw">Contraseña</label><input id="pw" type="password" placeholder="········"></div>
      <button class="btn btn-p" style="width:100%;padding:11px" data-act="login">Entrar</button>
      <div class="credito">© 2026 AGO · David JM</div>
    </div></div>`;
}

